import { User } from 'oidc-client-ts';
import { DiagramWithChildrenDto } from '../../../../app/api';

export function isDiagramOwner(diagram: Pick<DiagramWithChildrenDto, 'ownerId'>, user: User) {
  return diagram.ownerId === user.profile.sub;
}
